import { environment } from '@environment/environments';
import { APP_URLS } from '@/routes/app.paths';

export const LOGIN_URL = `${environment.baseUrl}/pahdp-user/v1/login`;
export const FORGOT_PASSWORD_URL = `${environment.baseUrl}/pahdp-user/v1/forgot-password`;
export const CONFIRM_FORGOT_PASSWORD_URL = `${environment.baseUrl}/pahdp-user/v1/confirm-forgot-password`;
export const FORCE_CHANGE_PASSWORD_URL = `${environment.baseUrl}/pahdp-user/v1/force-change-password`;
export const SAML_TOKEN_URL = `${environment.baseUrl}/pahdp-user/v1/saml-token`;

const SAML_REDIRECT_URI = `${environment.sso.frontendUrl}${APP_URLS.samlCallback}/`;

const ssoAuthorizeParams = new URLSearchParams({
  identity_provider: environment.sso.identityProvider,
  redirect_uri: SAML_REDIRECT_URI,
  response_type: 'CODE',
  client_id: environment.sso.clientId,
  scope: 'email openid profile',
});
export const SSO_AUTHORIZE_URL = `${environment.sso.cognitoDomain}/oauth2/authorize?${ssoAuthorizeParams.toString()}`;
